import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 3l0 18","key":"svg-0"}],["path",{"d":"M10 18l-3 3l-3 -3","key":"svg-1"}],["path",{"d":"M7 21l0 -18","key":"svg-2"}],["path",{"d":"M20 6l-3 -3l-3 3","key":"svg-3"}]]

const IconArrowsDownUp = createReactComponent('outline', 'arrows-down-up', 'ArrowsDownUp', __iconNode);

export default IconArrowsDownUp;